import TradeRequest from '../pages/TradeRequest.vue';
import TradeRequestDirect from '../pages/TradeRequestDirect.vue';
import TradeRequestForm from '../pages/TradeRequestForm.vue';
import TradeRequestDirectForm from '../pages/TradeRequestDirectForm.vue';
import TradeRequestInformation from '../pages/TradeRequestInformation.vue';
import TradeRequestDirectInformation from '../pages/TradeRequestDirectInformation.vue';
import TradeRequestReport from '../components/TradeRequestReport.vue';
import TradeRequestDirectReport from '../components/TradeRequestDirectReport.vue';

const tradeRequestsRoutes = [
  {
    path: '/trade-request',
    name: 'درخواست مناقصه/استعلام قیمت',
    component: TradeRequest,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
    {
    path: '/trade-request-direct',
    name: 'سفارش مستقیم کالا/خدمات',
    component: TradeRequestDirect,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
  {
    path: '/trade-request-form',
    name: ' فرم ثبت',
    component: TradeRequestForm,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
    {
    path: '/trade-request-direct-form',
    name: ' فرم ثبت سفارش مستقیم',
    component: TradeRequestDirectForm,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
   {
    path: '/trade-request-direct-edit/:id',
    name: ' فرم ویرایش',
    component: TradeRequestDirectForm,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
  {
    path: '/trade-request-edit/:id',
    name: ' فرم ویرایش',
    component: TradeRequestForm,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
  {
    path: '/trade-request-info/:id',
    name: 'مشاهده جزییات',
    component: TradeRequestInformation,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
    {
    path: '/trade-request-direct-info/:id',
    name: 'مشاهده جزییات',
    component: TradeRequestDirectInformation,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
  {
    path: '/trade-request-report/:id',
    name: 'گزارش درخواست ',
    component: TradeRequestReport,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
    {
    path: '/trade-request-direct-report/:id',
    name: 'گزارش سفارش مستقیم ',
    component: TradeRequestDirectReport,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
];

export default tradeRequestsRoutes;
